import {GameColor} from '../GameColor'
import {Sound} from '../Sound'
import {showRulebookPopup} from '../ui_rulebook/UIRulebookPopupGlobal'
import {createDivIn, createExternalImgIn, createImgIn, setElementOnClick} from '../ui_utils/DomUtils'
import {UIChatPostText} from './UIChatPostText'
import {UIUtilsChat} from './UIUtilsChat'
import {ChatData} from '@colonist/shared-types'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables'
import {uiGameManager} from '../EntryShared'
import {UIPlayerOptionsPopup} from '../ui_player_options_popup/UIPlayerOptionsPopup'
import {PIXI} from '@colonist/pixi'

export class UIChatPostController {
    private readonly chatData: ChatData
    private readonly container: HTMLDivElement

    readonly post: HTMLDivElement

    private readonly textColorInGame: GameColor.Color = GameColor.Color.Gray0
    private readonly textColorInRoom: GameColor.Color = GameColor.Color.White

    private readonly isMessageSentInGame: boolean

    private readonly iconSize: number = 20

    constructor(container: HTMLDivElement, chatData: ChatData) {
        this.container = container
        this.chatData = chatData
        this.isMessageSentInGame = container.className.includes('game_chat')

        this.post = this.createPostDiv()

        if(chatData.profilePictureUrl) {
            const img = createExternalImgIn(this.post, chatData.profilePictureUrl, {key: 'strings:colonistCommon.utils.emptyString'})
            img.style.borderRadius = '50%'
            img.width = this.iconSize
            img.height = this.iconSize
        } else if(chatData.icon != undefined) {
            const img = createImgIn(this.post, chatData.icon)
            img.width = this.iconSize
            img.height = this.iconSize
        }

        const isLog = this.container.id == 'game-log-text'
        new UIChatPostText(this.post, this.chatData, this.textColorInGame, isLog)

        this.setEventHandlersForHelpLinks()
        this.setEventHandlerForOptionsPopup()
    }

    private createPostDiv(): HTMLDivElement {
        const post = createDivIn(this.container, 'message-post', '')
        if(!(UIUtilsEjsVariables.isUserOnMobileApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI)) post.style.color = this.isMessageSentInGame ? GameColor.getColor(this.textColorInGame) : GameColor.getColor(this.textColorInRoom)
        setElementOnClick(post, () => Sound.playSound(Sound.SoundType.Click))

        if(this.chatData.isCentered != true) return post
        post.classList.add('victory-text')
        post.style.color = UIUtilsChat.getTextColor('' + this.chatData.username, GameColor.getColor(this.textColorInGame))
        return post
    }

    private setEventHandlersForHelpLinks() {
        const linkElements = this.post.getElementsByTagName('a')

        for(const link of linkElements) {
            const url = new URL(link.href)

            if(url.hash == UIUtilsChat.OPEN_RULEBOOK_LINK_HASH) {
                setElementOnClick(link, () => {
                    uiGameManager.pauseController.pauseIfSinglePlayer()
                    showRulebookPopup()
                }, true, true)
                continue
            }
        }
    }

    private setEventHandlerForOptionsPopup() {
        if(!this.chatData.isSenderUser) return

        setElementOnClick(this.post, () => {
            const playerColor = this.chatData.username ? UIUtilsChat.getPlayerColorFromText(this.chatData.username) : undefined
            if(playerColor === undefined) return

            const playerValidator = uiGameManager.gameState.players.find((p) => p.color === playerColor)
            if(playerValidator === undefined) return

            const canvas = uiGameManager.canvasController
            const postPositionOnCanvasY = this.post.getBoundingClientRect().y - canvas.responsiveController.getCanvasY()
            const postPositionOnCanvasX = this.post.getBoundingClientRect().x - canvas.responsiveController.getCanvasX()
            const offsetY = this.post.getBoundingClientRect().height
            const popupX = postPositionOnCanvasX / canvas.appW
            const popupY = (postPositionOnCanvasY + offsetY) / canvas.appH
            const popupPosition = new PIXI.Point(popupX, popupY)
            const playerOptionsPopup = new UIPlayerOptionsPopup(uiGameManager, popupPosition, playerValidator)

            playerOptionsPopup.buildInGamePlayerOptionsPopup()
        })
    }
}
